import Hero from './comps/Hero';
import TrustedBy from './comps/TrustedBy';
import Features from './comps/Features';
import Testimonials from './comps/Testimonials';
import CallToAction from './comps/CallToAction';
import PortfolioInvite from './comps/PortfolioInvite';

const Home = () => {
  return (
    <div className='w-full flex flex-col justify-center items-center'>
        <Hero />  
        <Features />
        <TrustedBy />
        <Testimonials />
        <PortfolioInvite />
        <CallToAction />
    </div>
  );
};

export default Home;
